import moment from 'moment'

export type HeaderStyles = {
  borderClass: string
  bgClass: string
  bgHex: string
  cta?: string
  primaryTheme: 'warning' | 'danger' | undefined
  minutesUntilVisit: number
  isVisitFarOut: boolean
}

const COASTAL_BLUE_5 = '#f3f9fa'
const AMBER_5 = '#fefbf5'
const RED_5 = '#fcf6f4'

function getMinutesUntilVisit(dateTime?: string | null): number {
  if (!dateTime) return 0
  return moment(dateTime).diff(moment(), 'minutes')
}

export function computeHeaderStyles(dateTime?: string | null): HeaderStyles {
  const minutesUntilVisit = getMinutesUntilVisit(dateTime || '')

  // >5 min remaining: visit is far out
  if (minutesUntilVisit > 5) {
    return {
      minutesUntilVisit,
      borderClass: 'border-border-dark',
      bgClass: 'bg-coastal-blue-5',
      bgHex: COASTAL_BLUE_5,
      primaryTheme: undefined,
      isVisitFarOut: true,
    }
  }

  // <=5 min remaining or <5 min late
  if (minutesUntilVisit <= 5 && minutesUntilVisit > -5) {
    return {
      minutesUntilVisit,
      borderClass: 'border-border-highlight',
      bgClass: 'bg-coastal-blue-5',
      bgHex: COASTAL_BLUE_5,
      primaryTheme: undefined,
      isVisitFarOut: false,
    }
  }

  // >5 min late: yellow/warning
  if (minutesUntilVisit <= -5 && minutesUntilVisit > -15) {
    return {
      minutesUntilVisit,
      borderClass: 'border-amber-50',
      bgClass: 'bg-amber-5',
      bgHex: AMBER_5,
      primaryTheme: 'warning',
      isVisitFarOut: false,
    }
  }

  // >15 min late: red/danger (can move to incomplete)
  return {
    minutesUntilVisit,
    borderClass: 'border-border-error',
    bgClass: 'bg-red-5',
    bgHex: RED_5,
    primaryTheme: 'danger',
    isVisitFarOut: false,
    cta: 'Move to Incomplete',
  }
}
